"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datePiecesFromDateComparator = void 0;
const datePiecesFromDateComparator = (comparator) => {
    const pieces = comparator.split(/[-|+]/);
    const yearMatch = pieces.find((piece) => piece.match(/^[0-9]+y$/))?.match(/[0-9]+/)?.[0];
    const monthMatch = pieces.find((piece) => piece.match(/^[0-9]+m$/))?.match(/[0-9]+/)?.[0];
    const dayMatch = pieces.find((piece) => piece.match(/^[0-9]+d$/))?.match(/[0-9]+/)?.[0];
    return {
        years: yearMatch ? +yearMatch : 0,
        months: monthMatch ? +monthMatch : 0,
        days: dayMatch ? +dayMatch : 0,
    };
};
exports.datePiecesFromDateComparator = datePiecesFromDateComparator;
